export const FACEBOOK_EVENTS = {
	PAGE_VIEW: "PageView",
	REACT_PAGE_VIEW: "ReactPageView",
	VIEW_CONTENT_SCALE: "ViewContentScale",
	VIEW_CONTENT_PLAN: "ViewContentPlan",
	ADD_TO_CART: "AddToCart",
	INITIATE_CHECKOUT: "InitiateCheckout",
	PURCHASE: "Purchase",
	LEAD: "Lead",
	PAYPAL_PAYMENT: "PayPalPayment",
	CREDIT_CARD_PAYMENT: "CreditCardPayment",
};

export const createOrderObject = (selectedScale, selectedPlan) => {
	if (!selectedPlan)
		return;

	return {
		content_ids: {
			plan: selectedPlan.id,
			scale: selectedScale && selectedScale.id,
		},
		order: [
			{ plan: selectedPlan},
			{ scale: selectedScale && selectedScale },
		],
		currency: "USD",
		num_items: selectedScale ? 2 : 1,
		value: selectedScale ? (selectedPlan.price + selectedScale.price) : selectedPlan.price,
	};
};

export const createScaleObject = (scale) => ({
		scale: scale,
		content_ids: scale.id,
		content_name: scale.name,
		content_type: scale.color,
		currency: "USD",
		value: scale.price,
});

export const createPlanObject = (plan) => ({
	plan: plan,
	content_ids: plan.id,
	content_name: plan.display_name,
	content_type: plan.name,
	currency: "USD",
	value: plan.price,
});

export const sha256_hashing = async (message) => {
	if (!message) {
		return null;
	}

	// encode as UTF-8
	const msgBuffer = new TextEncoder().encode(message.toLowerCase());

	// hash the message
	const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

	// convert ArrayBuffer to Array
	const hashArray = Array.from(new Uint8Array(hashBuffer));

	// convert bytes to hex string
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");

	return hashHex;
};
